import React from 'react';
import Attribute from './common';
import { SubTitle, SubText } from '../../../common';

const notice = {
    catS: {
        title: 'Category S',
        description: `The vehicle is repairable but has been structurally damaged.
		Can re-appear on road.`,
    },
    catN: {
        title: 'Category N',
        description: `The vehicle is repairable and has not been structurally damaged.
		Can re-appear on road.`,
    },
};

interface NoticeContents {
    title: string;
    description: string;
}

interface Notice {
    catS: NoticeContents;
    catN: NoticeContents;
}

interface Props {
    passed: boolean;
};

const NotCatSN: React.FC<Props> = ({ passed }) => {
    const { catS, catN }: Notice = notice;
    return (
        <Attribute name="Not Cat S/N" passed={passed}>
            <SubTitle>{catS.title}</SubTitle>
            <SubText>{catS.description}</SubText>
            <SubTitle>{catN.title}</SubTitle>
            <SubText>{catN.description}</SubText>
        </Attribute>
    );
};

export default NotCatSN;
